import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js'
import {
  Validator
} from 'vee-validate'
export default {
  name: 'company-profile',
  components: {},
  props: [],
  data() {
    return {
      userid: '',
      companyaction: '',
      Statusaction: '',
      listCompanyData: [],
      listStateData: [],
      listCityData: [],
      addcompany: {
        companyname: '',
        businesstype: '',
        companypersonemail: '',
        companyaddress: '',
        companyaddress2: '',
        country: '',
        state: '',
        city: '',
        pincode: '',
        companypersonname: '',
        companypersonmobile: '',
        companypersonphone: '',
        companyregisternum: '',
        companypanid: '',
        companygstnum: '',
        companyloginemail: '',
        status: '',
        password: ''
      }

    }
  },
  computed: {



  },
  mounted() {
    var permissionEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);

    // var logindata = JSON.parse(localStorage.getItem('userdetail'));
    // console.log("logindata", logindata);
    var userid = userdetail.userid;
    this.getsingleCompanyData(userid)
    this.getStateList()

  },
  methods: {
    addNewCompany() {
      this.addcompany.companyname = '',
        this.addcompany.companypersonemail = '',
        this.addcompany.companyaddress = '',
        this.addcompany.companyaddress2 = '',
        this.addcompany.companycountry = '',
        this.addcompany.companystate = '',
        this.addcompany.companycity = '',
        this.addcompany.companypincode = '',
        this.addcompany.companypersonname = '',
        this.addcompany.companypersonmobile = '',
        this.addcompany.companypersonphone = '',
        this.addcompany.companyregisternum = '',
        this.addcompany.companypanid = '',
        this.addcompany.companygstnum = '',
        this.addcompany.companyloginemail = '',
        this.addcompany.password = '',
        this.companyaction = 'add'
      this.addcompanymodal = true
    },



    getStateList() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({})
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'stateList',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })

        .then(result => {
          this.listStateData = result.data

        }, error => {
          console.error(error)
        })
    },


    getCityList() {
      //debugger
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        "statename": this.addcompany.companystate
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cityList',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          this.listCityData = result.data

        }, error => {
          console.error(error)
        })
    },

    getsingleCompanyData(userid) {
      this.input = ({
        companyid: userid
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'GetSingleCompanyData',
          'data': this.input
        })
        .then(result => {
          this.listCompanyData = result['data']['dataset'][0]
          //console.log(this.listCompanyData);
          this.addcompany = this.listCompanyData
          this.addcompany.companystate = this.listCompanyData.state
          this.addcompany.companycity = this.addcompany.city

          this.getCityList();
          //  console.log(listStateData)
        }, error => {
          console.error(error)
        })
    },





    saveCompany() {
      axios.post(apiUrl.api_url + 'updateCompany', {
          'companyid': this.companyid,
          'companyname': this.addcompany.companyname,
          'companypersonname': this.addcompany.companypersonname,
          //  'businesstype': this.addcompany.businesstype,
          'companyname': this.addcompany.companyname,
          'companyaddress': this.addcompany.companyaddress,
          'companyaddress2': this.addcompany.companyaddress2,
          'city': this.addcompany.city,
          'state': this.addcompany.companystate,
          'country': this.addcompany.companycountry,
          'companypanid': this.addcompany.companypanid,
          'companygstnum': this.addcompany.companygstnum,
          'companyregisternum': this.addcompany.companyregisternum,
          'companypersonemail': this.addcompany.companypersonemail,
          'companypersonphone': this.addcompany.companypersonphone,
          'companypersonmobile': this.addcompany.companypersonmobile,
          //  'userid': 15,
          'pincode': this.addcompany.companypincode

        })
        .then((response) => {
          if (response.data.msg > 0) {
            this.$alertify.success("Company Record saved Successfully")
            this.addcompanymodal = false
          }

        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },


    onSubmit: function() {
      this.$validator.validateAll().then(() => {
        console.log('form is valid', this.model)
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    }

  }
}


// WEBPACK FOOTER //
// ./src/views/components/companyProfile/companyProfile.component.js